(function(){
  function readJSON(id){
    var el=document.getElementById(id);
    try{return el?JSON.parse(el.textContent||'[]'):[]}catch(_){return[]}
  }
  function normalize(a){
    return (a||[]).map(function(x){return String(x||'').trim().toLowerCase()})
  }
  function keyFromVariant(v){
    var opts=Array.isArray(v.options)?v.options:[v.option1,v.option2,v.option3].filter(Boolean);
    return normalize(opts).join('||')
  }
  function buildMaps(pv,sv){
    var idToKey={},sampleMap={};
    pv.forEach(function(v){idToKey[String(v.id)]=keyFromVariant(v)});
    sv.forEach(function(v){sampleMap[keyFromVariant(v)]=String(v.id)});
    return{idToKey:idToKey,sampleMap:sampleMap}
  }
  function currentVariantId(pv){
    var el=document.querySelector('form[action="/cart/add"] input[name="id"], input[name="id"][type="hidden"], select[name="id"], input[name="id"]');
    if(el&&el.value)return String(el.value);
    if(pv&&pv.length===1)return String(pv[0].id);
    var qs=new URLSearchParams(location.search).get('variant');
    if(qs)return String(qs);
    return ''
  }
  function firstAvailableSample(sv){
    var a=sv.find(function(v){return v.available});
    return a?String(a.id):(sv[0]?String(sv[0].id):'')
  }
  function showMsgAutoHide(ok){
    var m=document.querySelector('.sample-order-message');
    if(!m)return;
    m.textContent=ok?'✅ Sample added to cart':'Could not add sample';
    m.style.display='block';
    m.style.background=ok?'var(--bg-accent)':'#fee';
    clearTimeout(showMsgAutoHide.t);
    showMsgAutoHide.t=setTimeout(function(){m.style.display='none'},2200)
  }
  function openMiniCartModal(product){
    if(typeof window.showThemeModal!=='function')return;
    var thumbUrl='';
    if(window.theme&&theme.Shopify&&product.image){
      thumbUrl=theme.Shopify.formatImage(product.image,'300x')
    }else if(product.image){
      thumbUrl=product.image
    }
    var imgAlt='';
    if(product.image&&product.image.alt){
      imgAlt=product.image.alt
    }
    var variantHtml='';
    try{
      if(product.price){
        if(window.theme&&theme.Shopify){
          var priceHtml='<span class="theme-money">'+theme.Shopify.formatMoney(product.price,theme.money_format_with_code_preference)+'</span>';
          variantHtml+='<p class="cart-product__content__price">'+priceHtml+'</p>'
        }
      }
    }catch(_){}
    if(product.selling_plan_allocation&&product.selling_plan_allocation.selling_plan&&product.selling_plan_allocation.selling_plan.name){
      variantHtml+='<p class="cart-product__content__meta">'+product.selling_plan_allocation.selling_plan.name+'</p>'
    }
    if(product.options_with_values&&product.options_with_values.length){
      product.options_with_values.forEach(function(option){
        if(option.name!=="Title"&&option.value!=="Default Title"){
          variantHtml+='<p class="cart-product__content__meta">'+option.name+': '+option.value+'</p>'
        }
      })
    }
    var noCheckoutButton=false;
    var addedText=(window.theme&&theme.strings&&theme.strings.productAddedToCart)?theme.strings.productAddedToCart:'Added to cart';
    var viewCartText=(window.theme&&theme.strings&&theme.strings.viewCart)?theme.strings.viewCart:'View cart';
    var checkoutText=(window.theme&&theme.strings&&theme.strings.popupCheckout)?theme.strings.popupCheckout:'Checkout';
    var cartUrl=(window.theme&&theme.routes&&theme.routes.cart_url)?theme.routes.cart_url:'/cart';
    var checkoutUrl=(window.theme&&theme.routes&&theme.routes.checkout)?theme.routes.checkout:'/checkout';
    var tickIcon=(window.theme&&theme.icons&&theme.icons.tick)?theme.icons.tick:'';
    var html=[
      '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
      '<div class="inner" style="top:120px">',
      '<a href="#" data-modal-close class="modal-close">&times;</a>',
      '<h4 id="added-to-cart-title">'+tickIcon+addedText+'</h4>',
      '<div class="cart-product">',
      '<div class="cart-product__image"><img src="'+thumbUrl+'" alt="'+imgAlt+'"/></div>',
      '<div class="cart-product__content">',
      '<p class="cart-product__content__title">'+product.product_title+'</p>',
      variantHtml,
      '</div>',
      '</div>',
      '<p class="links '+(noCheckoutButton?'links--no-checkout':'')+'">',
      '<a href="'+cartUrl+'" class="button '+(noCheckoutButton?'':'alt')+'">'+viewCartText+'</a>',
      noCheckoutButton?'':'<a href="'+checkoutUrl+'" class="button button--checkout" [data-cc-checkout-button]>'+checkoutText+'</a> ',
      '</p>',
      '</div>',
      '</div>'
    ].join('');
    window.showThemeModal(html,'added-to-cart',null);
    if(window.jQuery&&window.theme&&theme.routes&&theme.routes.cart_url){
      var $=window.jQuery;
      $.get(theme.routes.cart_url,function(data){
        var cartUpdateSelector='#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
        var $newCartObj=$( $.parseHTML('<div>'+data+'</div>') ).find(cartUpdateSelector);
        $(cartUpdateSelector).each(function(index){
          $($newCartObj[index]).find('[data-cc-animate]').removeAttr('data-cc-animate');
          $(this).replaceWith($newCartObj[index]);
          $(this).parent().find('[data-cc-animate]').removeAttr('data-cc-animate');
        });
      });
    }
  }
  function bind(){
    var pv=readJSON('current-product-variants');
    var sv=readJSON('sample-variants');
    if(!pv.length||!sv.length)return;
    var maps=buildMaps(pv,sv);
    document.addEventListener('click',async function(e){
      var btn=e.target.closest('[data-sample-add]');
      if(!btn)return;
      e.preventDefault();
      var mainId=currentVariantId(pv);
      if(!mainId){showMsgAutoHide(false);return}
      var key=maps.idToKey[mainId]||'';
      var sampleId=key?maps.sampleMap[key]:'';
      if(!sampleId)sampleId=firstAvailableSample(sv);
      if(!sampleId){showMsgAutoHide(false);return}
      var r;
      try{
        r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:sampleId,quantity:1})});
      }catch(_){
        showMsgAutoHide(false);
        return;
      }
      if(!r||!r.ok){showMsgAutoHide(false);return}
      var product=null;
      try{
        product=await r.json();
      }catch(_){}
      if(product)openMiniCartModal(product);
      showMsgAutoHide(true);
    });
  }
  if(document.readyState!=='loading')bind();else document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
})();
